import React, { useState, useEffect, useRef } from 'react';
import { MapPin, Filter, X, Move } from 'react-feather';
import { 
  MAP_CONFIG, 
  MAP_STYLES, 
  MARKER_CONFIG, 
  getMarkerColor, 
  createCustomIcon,
  loadGoogleMapsAPI,
  getDepartmentCenter
} from '../../utils/mapConfig';
import { obtenerEntidades, obtenerMunicipios } from '../../actions/EntidadAction';
import workflowApi from '../../api/workflowApi';
import { FileText } from 'react-feather';
import { AppRegistration as InscripcionIcon } from '@mui/icons-material';

const ColombiaMap = () => {
  const mapRef = useRef(null);
  const sidebarRef = useRef(null);
  const allInfoWindowsRef = useRef([]);
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [activeInfoWindow, setActiveInfoWindow] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [workflowFilter, setWorkflowFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [entidadesMunicipios, setEntidadesMunicipios] = useState([]);
  const [municipiosData, setMunicipiosData] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [showFilters, setShowFilters] = useState(true);
  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);
  const [mapStyle, setMapStyle] = useState('default');
  const [estadosWorkflow, setEstadosWorkflow] = useState({});
  
  // Estados para el panel arrastrable
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [panelPosition, setPanelPosition] = useState({ x: 20, y: 100 });

  // NUEVAS REFERENCIAS para overlays persistentes
  const departmentOverlaysRef = useRef([]);
  const departmentLabelsRef = useRef([]);

  // Función para límites administrativos persistentes
  const createPersistentAdministrativeBorders = (mapInstance) => {
    if (!mapInstance || !window.google) return;
    
    console.log('Creando límites administrativos persistentes (solo nativos)...');
    
    // Limpiar overlays existentes
    clearAdministrativeBorders();
    
    try {
      // USAR SOLO CARACTERÍSTICAS NATIVAS DE GOOGLE MAPS
      // No intentar cargar URLs externas que están fallando
      console.log('Usando características nativas de Google Maps');
      createNativeAdministrativeBorders(mapInstance);
      
      console.log('Límites administrativos nativos configurados exitosamente');
      
    } catch (error) {
      console.warn('Error en límites administrativos nativos:', error);
    }
  };

  // Función para nombres de departamentos persistentes
  // REEMPLAZA tu función createPersistentDepartmentLabels con esta versión completa:
  const createPersistentDepartmentLabels = (mapInstance) => {
    if (!mapInstance || !window.google) return;
    
    console.log('Creando nombres de departamentos persistentes...');
    
    // Limpiar labels existentes
    clearDepartmentLabels();
    
    // Lista COMPLETA de departamentos de Colombia
    const departmentLabels = [
      { name: 'Antioquia', lat: 6.2442, lng: -75.5812 },
      { name: 'Atlántico', lat: 10.9685, lng: -74.7813 },
      { name: 'Bolívar', lat: 10.4236, lng: -75.5378 },
      { name: 'Boyacá', lat: 5.4539, lng: -73.3616 },
      { name: 'Caldas', lat: 5.0689, lng: -75.5174 },
      { name: 'Caquetá', lat: 1.6145, lng: -75.6062 },
      { name: 'Casanare', lat: 5.7589, lng: -71.9542 },
      { name: 'Cauca', lat: 2.4387, lng: -76.6147 },
      { name: 'Cesar', lat: 9.3109, lng: -73.6533 },
      { name: 'Chocó', lat: 5.6837, lng: -76.6581 },
      { name: 'Córdoba', lat: 8.7476, lng: -75.8814 },
      { name: 'Cundinamarca', lat: 4.7110, lng: -74.0721 },
      { name: 'Guainía', lat: 2.5667, lng: -67.9333 },
      { name: 'Guaviare', lat: 2.5667, lng: -72.6833 },
      { name: 'Huila', lat: 2.5358, lng: -75.5273 },
      { name: 'La Guajira', lat: 11.5444, lng: -72.9072 },
      { name: 'Magdalena', lat: 11.2408, lng: -74.1990 },
      { name: 'Meta', lat: 4.1420, lng: -73.6266 },
      { name: 'Nariño', lat: 1.2136, lng: -77.2811 },
      { name: 'Norte de Santander', lat: 7.8939, lng: -72.5078 },
      { name: 'Putumayo', lat: 0.4859, lng: -75.3973 },
      { name: 'Quindío', lat: 4.4610, lng: -75.6674 },
      { name: 'Risaralda', lat: 4.8133, lng: -75.6961 },
      { name: 'San Andrés', lat: 12.5847, lng: -81.7006 },
      { name: 'Santander', lat: 7.1193, lng: -73.1227 },
      { name: 'Sucre', lat: 9.2985, lng: -75.3969 },
      { name: 'Tolima', lat: 4.4389, lng: -75.2322 },
      { name: 'Valle del Cauca', lat: 3.4516, lng: -76.5320 },
      { name: 'Vaupés', lat: 1.2500, lng: -70.2333 },
      { name: 'Vichada', lat: 6.1167, lng: -67.4833 }
    ];
    
    departmentLabels.forEach(dept => {
      const labelOverlay = new window.google.maps.OverlayView();

      labelOverlay.onAdd = function() {
        const div = document.createElement('div');
        // div.style.cssText = `
        //   position: absolute;
        //   background: rgba(255, 255, 255, 0.0);
        //   border: none;
        //   border-radius: 4px;
        //   padding: 2px 6px;
        //   font-family: Arial, sans-serif;
        //   font-size: 12px;
        //   font-weight: bold;
        //   color: #1976D2;
        //   text-shadow: 1px 1px 1px rgba(255,255,255,0.8);
        //   white-space: nowrap;
        //   pointer-events: none;
        //   z-index: 1001;
        //   transform: translate(-50%, -50%);
        // `;
        div.style.cssText = `
          position: absolute;
          background: rgba(255, 255, 255, 0.9);
          border: 1px solid #1976D2;
          border-radius: 4px;
          padding: 2px 6px;
          font-family: Arial, sans-serif;
          font-size: 12px;
          font-weight: bold;
          color: #1976D2;
          text-shadow: 1px 1px 1px rgba(255,255,255,0.8);
          white-space: nowrap;
          pointer-events: none;
          z-index: 1001;
          transform: translate(-50%, -50%);
        `;
        div.textContent = dept.name;
        
        this.div_ = div;
        const panes = this.getPanes();
        panes.overlayLayer.appendChild(div);
      };

      labelOverlay.draw = function() {
        const overlayProjection = this.getProjection();
        const position = overlayProjection.fromLatLngToDivPixel(
          new window.google.maps.LatLng(dept.lat, dept.lng)
        );
        
        if (this.div_) {
          this.div_.style.left = position.x + 'px';
          this.div_.style.top = position.y + 'px';
        }
      };

      labelOverlay.onRemove = function() {
        if (this.div_) {
          this.div_.parentNode.removeChild(this.div_);
          this.div_ = null;
        }
      };

      labelOverlay.setMap(mapInstance);
      departmentLabelsRef.current.push(labelOverlay);
    });
    
    console.log('Nombres de departamentos persistentes creados');
  };

  // Función para datos oficiales de Colombia
  const createOfficialColombianBorders = async (mapInstance) => {
    if (!mapInstance || !window.google) return false;
    
    try {
      // API oficial de datos abiertos de Colombia
      const response = await fetch('https://www.datos.gov.co/api/geospatial/xdk5-pm3f?method=export&format=GeoJSON');
      
      if (response.ok) {
        const geoJsonData = await response.json();
        
        const dataLayer = new window.google.maps.Data();
        dataLayer.addGeoJson(geoJsonData);
        
        dataLayer.setStyle({
          strokeColor: '#1976D2',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: 'transparent',
          fillOpacity: 0,
          zIndex: 1000
        });
        
        dataLayer.setMap(mapInstance);
        departmentOverlaysRef.current.push(dataLayer);
        
        console.log('Datos oficiales de Colombia cargados exitosamente');
        return true;
      }
    } catch (error) {
      console.warn('No se pudieron cargar datos oficiales:', error);
    }
    
    return false;
  };

  // Función para características nativas de Google Maps (fallback confiable)
  const createNativeAdministrativeBorders = (mapInstance) => {
    if (!mapInstance || !window.google) return;
    
    console.log('Activando límites administrativos nativos y ocultando carreteras...');
    
    const currentStyles = mapInstance.get('styles') || [];
    
    const administrativeStyles = [
    // Límites de departamentos/provincias MUY visibles
    {
      featureType: 'administrative.province',
      elementType: 'geometry.stroke',
      stylers: [
        { color: '#1976D2' },
        { weight: 5 }, // Aumentado significativamente de 2 a 5
        { visibility: 'on' }
      ]
    },
    {
      featureType: 'administrative.province',
      elementType: 'labels.text.fill',
      stylers: [
        { color: '#1976D2' },
        { visibility: 'on' }
      ]
    },
    {
      featureType: 'administrative.province',
      elementType: 'labels.text.stroke',
      stylers: [
        { color: '#FFFFFF' },
        { weight: 4 }, // Aumentado para mejor contraste
        { visibility: 'on' }
      ]
    },
    // También forzar límites de localidad
    {
      featureType: 'administrative.locality',
      elementType: 'geometry.stroke',
      stylers: [
        { color: '#1976D2' },
        { weight: 3 },
        { visibility: 'on' }
      ]
    },
    // País con línea más gruesa
    {
      featureType: 'administrative.country',
      elementType: 'geometry.stroke',
      stylers: [
        { color: '#757575' },
        { weight: 4 }, // Aumentado de 1 a 4
        { visibility: 'on' }
      ]
    },
    // Forzar TODOS los elementos administrativos
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [
        { visibility: 'on' },
        { weight: 3 }
      ]
    },
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [
        { visibility: 'on' }
      ]
    }
  ];
  
    // Filtrar estilos existentes para remover administrativos duplicados
    const filteredStyles = currentStyles.filter(style => {
      return !(style.featureType && style.featureType.startsWith('administrative'));
    });

    const combinedStyles = [...filteredStyles, ...administrativeStyles];
    mapInstance.setOptions({ styles: combinedStyles });

    // const combinedStyles = [...currentStyles, ...administrativeStyles];
    // mapInstance.setOptions({ styles: combinedStyles });
    
    console.log('Límites administrativos activados y carreteras ocultadas');
  };



  // Funciones de limpieza
  const clearAdministrativeBorders = () => {
    if (departmentOverlaysRef.current && departmentOverlaysRef.current.length > 0) {
      departmentOverlaysRef.current.forEach(overlay => {
        try {
          if (overlay && typeof overlay.setMap === 'function') {
            overlay.setMap(null);
          }
        } catch (error) {
          console.warn('Error removiendo overlay administrativo:', error);
        }
      });
      departmentOverlaysRef.current = [];
    }
  };

  const clearDepartmentLabels = () => {
    if (departmentLabelsRef.current && departmentLabelsRef.current.length > 0) {
      departmentLabelsRef.current.forEach(overlay => {
        try {
          if (overlay && typeof overlay.setMap === 'function') {
            overlay.setMap(null);
          }
        } catch (error) {
          console.warn('Error removiendo label de departamento:', error);
        }
      });
      departmentLabelsRef.current = [];
    }
  };
  
  // Estados del workflow de inscripción
  const WORKFLOW_STATES = {
    INICIADO: { 
      id: 1, 
      codigo: 'INICIADO',
      label: 'Proceso Iniciado', 
      color: '#3498db',
      descripcion: 'Workflow iniciado - pendiente registro completo'
    },
    PENDIENTE_REGISTRO: { 
      id: 2, 
      codigo: 'PENDIENTE_REGISTRO',
      label: 'Pendiente Registro', 
      color: '#f39c12',
      descripcion: 'Esperando registro de entidad, usuarios y contactos'
    },
    REGISTRO_COMPLETADO: { 
      id: 3, 
      codigo: 'REGISTRO_COMPLETADO',
      label: 'Registro Completado', 
      color: '#2ecc71',
      descripcion: 'Entidad, usuarios y contactos registrados correctamente'
    },
    DOCUMENTOS_REVISION: { 
      id: 4, 
      codigo: 'DOCUMENTOS_REVISION',
      label: 'Documentos en Revisión', 
      color: '#9b59b6',
      descripcion: 'Documentos siendo revisados por auditor'
    },
    APROBADO: { 
      id: 5, 
      codigo: 'APROBADO',
      label: 'Aprobado', 
      color: '#27ae60',
      descripcion: 'Inscripción aprobada'
    },
    RECHAZADO: { 
      id: 6, 
      codigo: 'RECHAZADO',
      label: 'Rechazado', 
      color: '#e74c3c',
      descripcion: 'Inscripción rechazada'
    },
    PENDIENTE_DOCUMENTOS: { 
      id: 7, 
      codigo: 'PENDIENTE_DOCUMENTOS',
      label: 'Pendiente Documentos', 
      color: '#e67e22',
      descripcion: 'Esperando carga de documentos requeridos'
    },
    DOCUMENTOS_CARGADOS: { 
      id: 8, 
      codigo: 'DOCUMENTOS_CARGADOS',
      label: 'Documentos Cargados', 
      color: '#9b59b6',
      descripcion: 'Todos los documentos han sido cargados'
    },
    EN_REVISION_ADMIN: { 
      id: 9, 
      codigo: 'EN_REVISION_ADMIN',
      label: 'En Revisión Admin', 
      color: '#34495e',
      descripcion: 'Documentos siendo revisados por administrador'
    }
  };

  // Función global para cerrar TODOS los InfoWindows
  const cerrarTodosLosInfoWindows = () => {
    if (activeInfoWindow) {
      activeInfoWindow.close();
      setActiveInfoWindow(null);
    }
    
    allInfoWindowsRef.current.forEach(infoWindow => {
      if (infoWindow && infoWindow.close) {
        try {
          infoWindow.close();
        } catch (error) {
          console.warn('Error cerrando InfoWindow:', error);
        }
      }
    });
  };

  // Funciones para el panel arrastrable
  // Funciones para el panel arrastrable - CORREGIDAS
  const handleMouseDown = (e) => {
    if (e.target.closest('.no-drag')) return;
    
    setIsDragging(true);
    
    // Calcular offset basado en la posición actual del panel
    setDragOffset({
      x: e.clientX - panelPosition.x,
      y: e.clientY - panelPosition.y
    });
    
    // Prevenir selección de texto durante el arrastre
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    // Calcular nueva posición usando el offset correcto
    const newX = e.clientX - dragOffset.x;
    const newY = e.clientY - dragOffset.y;
    
    // Límites de la pantalla
    const maxX = window.innerWidth - 380; // ancho del panel
    const maxY = window.innerHeight - 100; // altura mínima visible
    
    setPanelPosition({
      x: Math.max(0, Math.min(newX, maxX)),
      y: Math.max(100, Math.min(newY, maxY))  // CAMBIADO: mínimo de 0 a 100
    });
    
    // Prevenir comportamiento por defecto
    e.preventDefault();
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Event listeners para el arrastre
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'grabbing';
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
    };
  }, [isDragging, dragOffset]);

  // USAR FUNCIÓN OPTIMIZADA DE MAPCONFIG - COPIADO EXACTAMENTE DEL ORIGINAL
  useEffect(() => {
    loadGoogleMapsAPI()
      .then(() => {
        console.log('Google Maps cargado via mapConfig');
        setGoogleMapsLoaded(true);
        // AUTOMÁTICAMENTE SALIR DEL LOADING CUANDO GOOGLE MAPS ESTÉ LISTO
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error cargando Google Maps:', error);
        console.warn('Continuando en modo de prueba...');
        setGoogleMapsLoaded(true);
        // TAMBIÉN SALIR DEL LOADING EN CASO DE ERROR
        setLoading(false);
      });

    // Cargar datos en paralelo
    cargarDatos();
  }, []);

  // USEEFFECT SIMPLIFICADO PARA INICIALIZACIÓN - COPIADO DEL ORIGINAL
  useEffect(() => {
    console.log('useEffect de inicialización (simplificado)...');
    if (googleMapsLoaded && mapRef.current && !map) {
      console.log('Condiciones cumplidas, inicializando...');
      initializeMap();
    }
  }, [googleMapsLoaded, mapStyle]);

  // USEEFFECT PARA MONITOREAR MAPREF Y FORZAR INICIALIZACIÓN - SIN DEPENDENCIAS
  useEffect(() => {
    console.log('mapRef cambió:', {
      current: mapRef.current,
      exists: !!mapRef.current,
      type: typeof mapRef.current
    });
    
    // INTENTAR INICIALIZAR EL MAPA CUANDO MAPREF ESTÉ DISPONIBLE
    if (mapRef.current && googleMapsLoaded && !map) {
      console.log('mapRef disponible, inicializando mapa...');
      initializeMap();
    }
  });

  // FUNCIÓN PROTEGIDA PARA INICIALIZAR EL MAPA - COPIADO DEL ORIGINAL
  const initializeMap = () => {
    // Verificaciones existentes
    if (map) {
      console.log('Mapa ya existe, cancelando inicialización');
      return;
    }
    
    if (!mapRef.current) {
      console.log('mapRef.current no disponible');
      return;
    }
    
    if (!window.google || !window.google.maps || !window.google.maps.Map) {
      console.log('Google Maps no completamente disponible');
      return;
    }

    console.log('Iniciando creación del mapa con límites administrativos...');

    try {
      // LIMPIAR overlays existentes ANTES de crear el mapa
      clearAdministrativeBorders();
      clearDepartmentLabels();
      
      // Estilos base
      const baseStyles = MAP_STYLES[mapStyle] || [];
      
      // Estilos administrativos SIMPLIFICADOS para evitar conflictos
      const administrativeStyles = [
        {
          featureType: 'administrative.province',
          elementType: 'geometry.stroke',
          stylers: [
            { color: '#1976D2' },
            { weight: 2 },
            { visibility: 'on' }
          ]
        },
        {
          featureType: 'administrative.province',
          elementType: 'labels.text.fill',
          stylers: [
            { color: '#1976D2' },
            { visibility: 'on' }
          ]
        },
        {
          featureType: 'administrative.country',
          elementType: 'geometry.stroke',
          stylers: [
            { color: '#757575' },
            { weight: 2 },
            { visibility: 'on' }
          ]
        }
      ];
      
      // Ocultar carreteras
      const hideRoadsStyles = [
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        }
      ];
      
      // Combinar estilos
      const combinedStyles = [...baseStyles, ...administrativeStyles, ...hideRoadsStyles];

      // Crear el mapa
      const mapInstance = new window.google.maps.Map(mapRef.current, {
        center: MAP_CONFIG.DEFAULT_CENTER,
        zoom: MAP_CONFIG.DEFAULT_ZOOM,
        styles: combinedStyles,
        ...MAP_CONFIG.MAP_OPTIONS,

        mapTypeControlOptions: {
          position: window.google.maps.ControlPosition.TOP_RIGHT,
          style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain']
        },
        fullscreenControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT_TOP
        },
        zoomControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT_CENTER
        },
        streetViewControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT_CENTER
        }


      });

      console.log('Mapa creado exitosamente');
      setMap(mapInstance);
      setLoading(false);

      // Crear nombres de departamentos después de que el mapa esté completamente cargado
      setTimeout(() => {
        createPersistentDepartmentLabels(mapInstance);
        console.log('Nombres de departamentos agregados');
      }, 1000); // Delay más largo para asegurar que el mapa esté listo

    } catch (error) {
      console.error('Error creando mapa:', error);
      setLoading(false);
    }
  };

  // Cargar datos de entidades y municipios
  const cargarDatos = async () => {
    try {
      console.log('Cargando datos del mapa...');
      
      // Cargar entidades municipios
      const entidadesResponse = await obtenerEntidades();
      if (entidadesResponse.status === 200) {
        const municipios = entidadesResponse.data.filter(entidad => entidad.tipoEntidadID === 1);
        console.log('Entidades municipios encontradas:', municipios.length);
        setEntidadesMunicipios(municipios);
        
        // Extraer departamentos únicos
        const departamentosUnicos = [...new Set(municipios.map(m => getDepartamentoFromEntidad(m)))];
        setDepartments(departamentosUnicos.filter(Boolean));
        
        // Cargar estados del workflow
        await cargarEstadosWorkflow(municipios);
      }
      
      // Cargar datos de municipios con coordenadas
      const municipiosResponse = await obtenerMunicipios();
      if (municipiosResponse.status === 200) {
        console.log('Datos de municipios con coordenadas:', municipiosResponse.data.length);
        setMunicipiosData(municipiosResponse.data);
      }
      
    } catch (error) {
      console.error('Error cargando datos:', error);
      // Usar datos mock en caso de error
      usarDatosMock();
    }
  };

  // Función para extraer el departamento de una entidad
  const getDepartamentoFromEntidad = (entidad) => {
    if (entidad.nombre && entidad.nombre.includes(' - ')) {
      return entidad.nombre.split(' - ')[1];
    }
    return entidad.departamento || entidad.nombreDepartamento || null;
  };

  // Obtener coordenadas de un municipio por su ID
  const obtenerCoordenadasMunicipio = (municipioID) => {
    if (!municipioID || !municipiosData.length) return null;
    
    const municipio = municipiosData.find(m => m.municipioID === municipioID);
    if (municipio && municipio.latitud && municipio.longitud) {
      return {
        lat: parseFloat(municipio.latitud),
        lng: parseFloat(municipio.longitud)
      };
    }
    return null;
  };

  // Cargar estados del workflow
  const cargarEstadosWorkflow = async (municipios) => {
    console.log('Cargando estados del workflow...');
    
    const estadosPromises = municipios.map(async (municipio) => {
      try {
        const entidadId = municipio.entidadID || municipio.id;
        const response = await workflowApi.obtenerEstadoInscripcion(entidadId);
        
        console.log('Data que esta SIENDO EVALUADA: ', response.data);

        if (response.status === 200 && response.data) {
          const estadoMapeado = mapearEstadoWorkflow(response.data.estado);
          return { entidadId, estado: estadoMapeado };
        }
      } catch (error) {
        return {
          entidadId: municipio.entidadID || municipio.id,
          estado: WORKFLOW_STATES.NO_INICIADO
        };
      }
      return null;
    });

    const resultados = await Promise.all(estadosPromises);
    const estadosMap = {};
    
    resultados.forEach(resultado => {
      if (resultado) {
        estadosMap[resultado.entidadId] = resultado.estado;
      }
    });
    
    setEstadosWorkflow(estadosMap);
    // Console.log para debugging de estados
    console.log('=== ESTADOS DE WORKFLOW CARGADOS ===');
    console.log('Total entidades procesadas:', municipios.length);
    console.log('Estados mapeados:', Object.keys(estadosMap).length);
    console.log('Estados detallados:', estadosMap);
    console.log('Resumen por estado:');
    Object.values(WORKFLOW_STATES).forEach(estado => {
      const count = Object.values(estadosMap).filter(e => e.id === estado.id).length;
      console.log(`- ${estado.label}: ${count} municipios`);
    });
    console.log('=====================================');
  };

  // Mapear estado del API al estado local
  const mapearEstadoWorkflow = (estadoData) => {
    if (!estadoData) return WORKFLOW_STATES.INICIADO; // Estado por defecto
    
    const estadoId = estadoData.estadoNegocioId || estadoData.estadoId || estadoData.id;
    if (estadoId) {
      const estadoIdInt = parseInt(estadoId);
      switch (estadoIdInt) {
        case 1: return WORKFLOW_STATES.INICIADO;
        case 2: return WORKFLOW_STATES.PENDIENTE_REGISTRO;
        case 3: return WORKFLOW_STATES.REGISTRO_COMPLETADO;
        case 4: return WORKFLOW_STATES.DOCUMENTOS_REVISION;
        case 5: return WORKFLOW_STATES.APROBADO;
        case 6: return WORKFLOW_STATES.RECHAZADO;
        case 7: return WORKFLOW_STATES.PENDIENTE_DOCUMENTOS;
        case 8: return WORKFLOW_STATES.DOCUMENTOS_CARGADOS;
        case 9: return WORKFLOW_STATES.EN_REVISION_ADMIN;
        default: return WORKFLOW_STATES.INICIADO;
      }
    }
    
    return WORKFLOW_STATES.INICIADO;
  };

  // Datos mock para pruebas
  const usarDatosMock = () => {
    console.log('Usando datos mock...');
    const mockMunicipalities = [
      {
        id: 1,
        entidadID: 1,
        nombre: "Bogotá D.C. - Cundinamarca",
        tipoEntidadID: 1,
        municipioID: 1
      },
      {
        id: 2,
        entidadID: 2,
        nombre: "Medellín - Antioquia",
        tipoEntidadID: 1,
        municipioID: 2
      },
      {
        id: 3,
        entidadID: 3,
        nombre: "Cali - Valle del Cauca",
        tipoEntidadID: 1,
        municipioID: 3
      }
    ];

    const mockMunicipiosData = [
      {
        municipioID: 1,
        nombre: "Bogotá D.C.",
        latitud: 4.7110,
        longitud: -74.0721
      },
      {
        municipioID: 2,
        nombre: "Medellín",
        latitud: 6.2442,
        longitud: -75.5812
      },
      {
        municipioID: 3,
        nombre: "Cali",
        latitud: 3.4516,
        longitud: -76.5320
      }
    ];

    setEntidadesMunicipios(mockMunicipalities);
    setMunicipiosData(mockMunicipiosData);
    setDepartments(['Cundinamarca', 'Antioquia', 'Valle del Cauca']);
    
    const estadosMock = {
      1: WORKFLOW_STATES.COMPLETADO,
      2: WORKFLOW_STATES.DOCUMENTOS_PENDIENTES,
      3: WORKFLOW_STATES.REGISTRO_COMPLETO
    };
    setEstadosWorkflow(estadosMock);
  };

  // Filtrar municipios según criterios
  const getFilteredMunicipalities = () => {
    return entidadesMunicipios.filter(municipio => {
      if (selectedDepartment) {
        const departamentoMunicipio = getDepartamentoFromEntidad(municipio);
        if (departamentoMunicipio !== selectedDepartment) {
          return false;
        }
      }

      if (workflowFilter) {
        const estadoMunicipio = estadosWorkflow[municipio.entidadID || municipio.id];
        if (!estadoMunicipio || estadoMunicipio.id !== parseInt(workflowFilter)) {
          return false;
        }
      }

      return true;
    });
  };

  // FUNCIÓN PARA ENFOCAR EN DEPARTAMENTO USANDO MAPCONFIG
  const focusOnDepartment = (departmentName) => {
    if (!map || !departmentName) {
      map?.setCenter(MAP_CONFIG.DEFAULT_CENTER);
      map?.setZoom(MAP_CONFIG.DEFAULT_ZOOM);
      return;
    }

    const center = getDepartmentCenter(departmentName);
    map.setCenter(center);
    map.setZoom(8);
  };

  const clearFilters = () => {
    setSelectedDepartment('');
    setWorkflowFilter('');
    
    if (map) {
      map.setCenter(MAP_CONFIG.DEFAULT_CENTER);
      map.setZoom(MAP_CONFIG.DEFAULT_ZOOM);
    }
  };

  // FUNCIÓN PARA CAMBIAR ESTILO DEL MAPA USANDO MAPCONFIG - MEJORADA
  const changeMapStyle = (styleName) => {
    console.log('Cambiando estilo del mapa a:', styleName);
    setMapStyle(styleName);
    
    if (map) {
      // Estilos administrativos que deben mantenerse SIEMPRE
      const permanentAdministrativeStyles = [
        {
          featureType: 'administrative.province',
          elementType: 'geometry.stroke',
          stylers: [
            { color: '#1976D2' },
            { weight: 2 },
            { visibility: 'on' }
          ]
        },
        {
          featureType: 'administrative.province',
          elementType: 'labels.text.fill',
          stylers: [
            { color: '#1976D2' },
            { visibility: 'on' }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'all',
          stylers: [
            { visibility: 'on' }
          ]
        }
      ];
      
      // Mantener carreteras ocultas
      const hideRoadsStyles = [
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        }
      ];
      
      // Manejar tipos de mapa específicos
      if (styleName === 'satellite') {
        map.setMapTypeId(window.google.maps.MapTypeId.SATELLITE);
        map.setOptions({ styles: [...permanentAdministrativeStyles, ...hideRoadsStyles] });
      } else if (styleName === 'hybrid') {
        map.setMapTypeId(window.google.maps.MapTypeId.HYBRID);
        map.setOptions({ styles: [...permanentAdministrativeStyles, ...hideRoadsStyles] });
      } else if (styleName === 'terrain') {
        map.setMapTypeId(window.google.maps.MapTypeId.TERRAIN);
        map.setOptions({ styles: [...permanentAdministrativeStyles, ...hideRoadsStyles] });
      } else {
        map.setMapTypeId(window.google.maps.MapTypeId.ROADMAP);
        
        // Para estilos personalizados, combinar con límites administrativos y sin carreteras
        const baseStyles = MAP_STYLES && MAP_STYLES[styleName] ? MAP_STYLES[styleName] : [];
        const combinedStyles = [...baseStyles, ...permanentAdministrativeStyles, ...hideRoadsStyles];
        
        map.setOptions({ styles: combinedStyles });
      }
      
      console.log('Estilo cambiado, límites administrativos preservados y carreteras ocultas');
    }
  };

  // CREAR MARCADORES - USANDO FUNCIONES UTILITARIAS DEL MAPCONFIG
  useEffect(() => {
    if (!map || !window.google) return;

    // Limpiar marcadores existentes
    markers.forEach(marker => {
      window.google.maps.event.clearInstanceListeners(marker);
      marker.setMap(null);
    });

    cerrarTodosLosInfoWindows();

    const filteredMunicipalities = getFilteredMunicipalities();
    const newMarkers = [];

    filteredMunicipalities.forEach(entidadMunicipio => {
      const estado = estadosWorkflow[entidadMunicipio.entidadID || entidadMunicipio.id] || WORKFLOW_STATES.NO_INICIADO;
      const coordenadas = obtenerCoordenadasMunicipio(entidadMunicipio.municipioID);
      
      console.log('*******ESTADO QUE SE ENVIA AL UTILS: ', estado);

      if (!coordenadas) {
        console.warn(`Sin coordenadas para ${entidadMunicipio.nombre}`);
        return;
      }

      // Usar función utilitaria para crear marcador
      const marker = new window.google.maps.Marker({
        position: coordenadas,
        map: map,
        title: entidadMunicipio.nombre,
        // icon: createCustomIcon(getMarkerColor(estado), MARKER_CONFIG.SIZES.MEDIUM),
        icon: createCustomIcon(estado.color, MARKER_CONFIG.SIZES.MEDIUM),
        animation: window.google.maps.Animation.DROP
      });

      const infoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="padding: 15px; max-width: 300px; font-family: Arial, sans-serif;">
            <h3 style="margin: 0 0 12px 0; color: #333; font-size: 16px; font-weight: 600;">
              ${entidadMunicipio.nombre}
            </h3>
            <div style="margin-bottom: 12px;">
              <strong style="color: #555;">Estado del workflow:</strong>
              <div style="
                display: inline-block;
                background-color: ${estado.color};
                color: white;
                padding: 4px 12px;
                border-radius: 16px;
                font-size: 12px;
                margin-left: 8px;
                font-weight: 500;
              ">
                ${estado.label}
              </div>
            </div>
            <div style="margin-bottom: 8px; color: #666; font-size: 14px;">
              <strong>Tipo:</strong> Municipio
            </div>
            <div style="margin-bottom: 8px; color: #666; font-size: 14px;">
              <strong>ID Entidad:</strong> ${entidadMunicipio.entidadID || entidadMunicipio.id}
            </div>
            <div style="margin-bottom: 12px; color: #666; font-size: 14px;">
              <strong>ID Municipio:</strong> ${entidadMunicipio.municipioID}
            </div>
            <button 
              onclick="window.open('/inscripcion/${entidadMunicipio.entidadID || entidadMunicipio.id}', '_blank')"
              style="
                background-color: #007bff;
                color: white;
                border: none;
                padding: 10px 16px;
                border-radius: 6px;
                cursor: pointer;
                font-size: 14px;
                font-weight: 500;
                width: 100%;
                transition: background-color 0.2s;
              "
            >
              Ver detalles del workflow
            </button>
          </div>
        `
      });

      marker.addListener('click', () => {
        markers.forEach(m => {
          if (m.infoWindow) {
            m.infoWindow.close();
          }
        });
        
        infoWindow.open(map, marker);
        setActiveInfoWindow(infoWindow);
      });

      marker.infoWindow = infoWindow;
      newMarkers.push(marker);
    });

    allInfoWindowsRef.current = newMarkers.map(m => m.infoWindow);
    setMarkers(newMarkers);

    if (newMarkers.length > 0 && newMarkers.length < entidadesMunicipios.length) {
      const bounds = new window.google.maps.LatLngBounds();
      newMarkers.forEach(marker => {
        bounds.extend(marker.getPosition());
      });
      map.fitBounds(bounds);
      
      const listener = window.google.maps.event.addListener(map, 'idle', () => {
        if (map.getZoom() > 10) map.setZoom(10);
        window.google.maps.event.removeListener(listener);
      });
    }
  }, [map, selectedDepartment, workflowFilter, entidadesMunicipios, municipiosData, estadosWorkflow]);

  // Cerrar InfoWindow al hacer click en el mapa
  useEffect(() => {
    if (!map) return;

    const mapClickListener = map.addListener('click', () => {
      cerrarTodosLosInfoWindows();
    });

    return () => {
      if (mapClickListener) {
        window.google.maps.event.removeListener(mapClickListener);
      }
    };
  }, [map]);

  // ENFOCAR DEPARTAMENTO CUANDO SE SELECCIONA
  useEffect(() => {
    if (selectedDepartment && map) {
      console.log('Departamento seleccionado:', selectedDepartment);
      focusOnDepartment(selectedDepartment);
    } else if (!selectedDepartment && map) {
      console.log('Sin departamento seleccionado, reseteando mapa');
      if (map) {
        map.setCenter(MAP_CONFIG.DEFAULT_CENTER);
        map.setZoom(MAP_CONFIG.DEFAULT_ZOOM);
      }
    }
  }, [selectedDepartment, map]);

  const hasActiveFilters = selectedDepartment || workflowFilter;

  // Estilos
  const styles = {
    container: {
      position: 'relative',
      width: '100%',
      height: '100vh',
      // backgroundColor: '#f8f9fa',
      backgroundColor: 'transparent',
      paddingTop: '80px' // AGREGAR ESTA LÍNEA
    },
    mapContainer: {
      position: 'absolute',
      top: '80px', // CAMBIAR de 0 a '80px'
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'hidden'
    },
    map: {
      width: '100%',
      height: '100%'
    },
    sidebar: {
      position: 'absolute',
      top: panelPosition.y,
      left: panelPosition.x,
      width: '360px',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: isDragging 
        ? '0 8px 32px rgba(0, 0, 0, 0.24)' 
        : '0 4px 16px rgba(0, 0, 0, 0.15)',
      zIndex: 1000,
      overflow: 'hidden',
      border: '1px solid #e9ecef',
      cursor: isDragging ? 'grabbing' : 'grab',
      transition: isDragging ? 'none' : 'box-shadow 0.2s ease',
      userSelect: 'none'
    },
    dragHandle: {
      padding: '12px 20px',
      backgroundColor: '#007bff',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: isDragging ? 'grabbing' : 'grab',
      userSelect: 'none'
    },
    title: {
      fontSize: '16px',
      fontWeight: '600',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    subtitle: {
      fontSize: '12px',
      opacity: 0.9,
      margin: '2px 0 0 0'
    },
    content: {
      padding: '20px',
      maxHeight: '70vh',
      overflowY: 'auto'
    },
    section: {
      marginBottom: '20px'
    },
    sectionTitle: {
      fontSize: '14px',
      fontWeight: '600',
      marginBottom: '12px',
      color: '#333',
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    },
    filterGroup: {
      marginBottom: '16px'
    },
    label: {
      display: 'block',
      fontSize: '13px',
      fontWeight: '500',
      marginBottom: '6px',
      color: '#555'
    },
    select: {
      width: '100%',
      padding: '8px 12px',
      border: '1px solid #ddd',
      borderRadius: '6px',
      fontSize: '14px',
      backgroundColor: 'white',
      cursor: 'pointer'
    },
    buttonGroup: {
      display: 'flex',
      gap: '8px',
      marginBottom: '16px'
    },
    button: {
      padding: '8px 12px',
      backgroundColor: '#6c757d',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      transition: 'background-color 0.2s'
    },
    primaryButton: {
      padding: '8px 12px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      transition: 'background-color 0.2s'
    },
    legendBox: {
      backgroundColor: '#f8f9fa',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #e9ecef'
    },
    legendTitle: {
      fontSize: '13px',
      fontWeight: '600',
      marginBottom: '12px',
      color: '#333'
    },
    legendItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '8px'
    },
    legendColor: {
      width: '14px',
      height: '14px',
      borderRadius: '50%',
      marginRight: '10px',
      border: '2px solid #fff',
      boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
    },
    legendText: {
      fontSize: '12px',
      color: '#666',
      lineHeight: 1.4
    },
    statsBox: {
      backgroundColor: '#f8f9fa',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #e9ecef'
    },
    statsTitle: {
      fontSize: '13px',
      fontWeight: '600',
      marginBottom: '12px',
      color: '#333'
    },
    statsItems: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    statsItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    statsLabel: {
      fontSize: '12px',
      color: '#666'
    },
    statsValue: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#333'
    },
    toggleButton: {
      position: 'absolute',
      top: '100px',  // CAMBIAR de '80px' a '100px'
      right: '20px',
      backgroundColor: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '44px',
      height: '44px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1001,
      transition: 'all 0.2s ease'
    },
    loadingOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      zIndex: 2000
    },
    debugBox: {
      backgroundColor: '#fff3cd',
      border: '1px solid #ffeaa7',
      borderRadius: '8px',
      padding: '12px',
      marginBottom: '16px'
    },
    debugTitle: {
      fontSize: '12px',
      fontWeight: '600',
      marginBottom: '8px',
      color: '#856404'
    },
    debugText: {
      fontSize: '10px',
      color: '#856404',
      lineHeight: 1.4
    },
    municipalityBox: {
      backgroundColor: '#f8f9fa',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #e9ecef'
    },
    municipalityTitle: {
      fontSize: '13px',
      fontWeight: '600',
      marginBottom: '12px',
      color: '#333'
    },
    municipalityScrollContainer: {
      maxHeight: '300px',
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    municipalityChip: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 12px',
      marginBottom: '8px',
      border: '2px solid',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      backgroundColor: 'white',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      position: 'relative'
    },
    municipalityChipColor: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      marginRight: '10px',
      flexShrink: 0
    },
    municipalityChipText: {
      flex: 1,
      minWidth: 0
    },
    municipalityName: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#333',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    municipalityDepartment: {
      fontSize: '10px',
      color: '#666',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    municipalityChipStatus: {
      fontSize: '9px',
      fontWeight: '500',
      color: 'white',
      padding: '2px 6px',
      borderRadius: '10px',
      marginLeft: '8px',
      whiteSpace: 'nowrap',
      maxWidth: '80px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    municipalityNoCoords: {
      fontSize: '10px',
      marginLeft: '4px',
      opacity: 0.7
    },
    municipalityEmpty: {
      fontSize: '12px',
      color: '#666',
      fontStyle: 'italic',
      textAlign: 'center',
      padding: '20px'
    }
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loadingOverlay}>
          <div style={{ fontSize: '18px', marginBottom: '10px' }}>Cargando mapa...</div>
          <div style={{ fontSize: '14px', color: '#666' }}>Inicializando Google Maps y datos...</div>
        </div>
      </div>
    );
  }

  // Función para cargar límites administrativos
  const loadAdministrativeBoundaries = (mapInstance) => {
    if (!mapInstance || !window.google) return;
    
    try {
      // Cargar límites administrativos de Colombia
      mapInstance.data.loadGeoJson('https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/world.geojson');
      
      // Alternativamente, usar específicamente para Colombia:
      // mapInstance.data.loadGeoJson('https://gist.githubusercontent.com/john-guerra/43c7656821069d00dcbc/raw/3aadedf47badbdac823b00ddf259b3565c0d681e/colombia.geo.json');
      
      // Estilo para las líneas de límites
      mapInstance.data.setStyle({
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'transparent',
        fillOpacity: 0
      });
      
      console.log('Límites administrativos cargados');
    } catch (error) {
      console.warn('Error cargando límites administrativos:', error);
    }
  };

  // Función para cargar límites administrativos - fuente oficial de colombia
  // const createOfficialColombianBorders = async (mapInstance) => {
  //   if (!mapInstance || !window.google) return;
    
  //   console.log('Intentando cargar datos oficiales de Colombia...');
    
  //   try {
  //     // API oficial de datos abiertos de Colombia (si está disponible)
  //     const response = await fetch('https://www.datos.gov.co/api/geospatial/xdk5-pm3f?method=export&format=GeoJSON');
      
  //     if (response.ok) {
  //       const geoJsonData = await response.json();
        
  //       const dataLayer = new window.google.maps.Data();
  //       dataLayer.addGeoJson(geoJsonData);
        
  //       dataLayer.setStyle({
  //         strokeColor: '#1976D2',
  //         strokeOpacity: 0.8,
  //         strokeWeight: 2,
  //         fillColor: 'transparent',
  //         fillOpacity: 0,
  //         zIndex: 1000
  //       });
        
  //       dataLayer.setMap(mapInstance);
  //       departmentOverlaysRef.current.push(dataLayer);
        
  //       console.log('Datos oficiales de Colombia cargados exitosamente');
  //       return true;
  //     }
  //   } catch (error) {
  //     console.warn('No se pudieron cargar datos oficiales:', error);
  //   }
    
  //   return false;
  // };

  // datos esepecíficos de Colombia
  const loadColombiaBoundaries = async (mapInstance) => {
    try {
      // URL con datos GeoJSON de departamentos de Colombia
      const response = await fetch('https://gist.githubusercontent.com/john-guerra/43c7656821069d00dcbc/raw/3aadedf47badbdac823b00ddf259b3565c0d681e/colombia.geo.json');
      const geoJsonData = await response.json();
      
      mapInstance.data.addGeoJson(geoJsonData);
      
      // Estilo para los departamentos
      mapInstance.data.setStyle((feature) => {
        return {
          strokeColor: '#2196F3',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: 'transparent',
          fillOpacity: 0
        };
      });
      
      console.log('Límites de departamentos de Colombia cargados');
    } catch (error) {
      console.warn('Error cargando límites de Colombia:', error);
    }
  };

  // Función para agregar nombres de departamentos
  // Función CORREGIDA - reemplaza la función addDepartmentLabels en tu archivo
  const addDepartmentLabels = (mapInstance) => {
    if (!mapInstance || !window.google) return;
    
    const departmentLabels = [
      { name: 'Antioquia', lat: 6.2442, lng: -75.5812 },
      { name: 'Atlántico', lat: 10.9685, lng: -74.7813 },
      { name: 'Bolívar', lat: 10.4236, lng: -75.5378 },
      { name: 'Boyacá', lat: 5.4539, lng: -73.3616 },
      { name: 'Caldas', lat: 5.0689, lng: -75.5174 },
      { name: 'Caquetá', lat: 1.6145, lng: -75.6062 },
      { name: 'Casanare', lat: 5.7589, lng: -71.9542 },
      { name: 'Cauca', lat: 2.4387, lng: -76.6147 },
      { name: 'Cesar', lat: 9.3109, lng: -73.6533 },
      { name: 'Chocó', lat: 5.6837, lng: -76.6581 },
      { name: 'Córdoba', lat: 8.7476, lng: -75.8814 },
      { name: 'Cundinamarca', lat: 4.7110, lng: -74.0721 },
      { name: 'Guainía', lat: 2.5667, lng: -67.9333 },
      { name: 'Guaviare', lat: 2.5667, lng: -72.6833 },
      { name: 'Huila', lat: 2.5358, lng: -75.5273 },
      { name: 'La Guajira', lat: 11.5444, lng: -72.9072 },
      { name: 'Magdalena', lat: 11.2408, lng: -74.1990 },
      { name: 'Meta', lat: 4.1420, lng: -73.6266 },
      { name: 'Nariño', lat: 1.2136, lng: -77.2811 },
      { name: 'Norte de Santander', lat: 7.8939, lng: -72.5078 },
      { name: 'Putumayo', lat: 0.4859, lng: -75.3973 },
      { name: 'Quindío', lat: 4.4610, lng: -75.6674 },
      { name: 'Risaralda', lat: 4.8133, lng: -75.6961 },
      { name: 'San Andrés', lat: 12.5847, lng: -81.7006 },
      { name: 'Santander', lat: 7.1193, lng: -73.1227 },
      { name: 'Sucre', lat: 9.2985, lng: -75.3969 },
      { name: 'Tolima', lat: 4.4389, lng: -75.2322 },
      { name: 'Valle del Cauca', lat: 3.4516, lng: -76.5320 },
      { name: 'Vaupés', lat: 1.2500, lng: -70.2333 },
      { name: 'Vichada', lat: 6.1167, lng: -67.4833 }
    ];
    
    departmentLabels.forEach(dept => {
      // Crear overlay personalizado para texto fijo
      const labelOverlay = new window.google.maps.OverlayView();

      labelOverlay.onAdd = function() {
        const div = document.createElement('div');
        div.style.cssText = `
          position: absolute;
          background: rgba(255, 255, 255, 0.9);
          border: 1px solid #1976D2;
          border-radius: 4px;
          padding: 2px 6px;
          font-family: Arial, sans-serif;
          font-size: 12px;
          font-weight: bold;
          color: #1976D2;
          text-shadow: 1px 1px 1px rgba(255,255,255,0.8);
          white-space: nowrap;
          pointer-events: none;
          z-index: 100;
          transform: translate(-50%, -50%);
        `;
        div.textContent = dept.name;
        
        this.div_ = div;
        const panes = this.getPanes();
        panes.overlayLayer.appendChild(div);
      };

      labelOverlay.draw = function() {
        const overlayProjection = this.getProjection();
        const position = overlayProjection.fromLatLngToDivPixel(
          new window.google.maps.LatLng(dept.lat, dept.lng)
        );
        
        if (this.div_) {
          this.div_.style.left = position.x + 'px';
          this.div_.style.top = position.y + 'px';
        }
      };

      labelOverlay.onRemove = function() {
        if (this.div_) {
          this.div_.parentNode.removeChild(this.div_);
          this.div_ = null;
        }
      };

      labelOverlay.setMap(mapInstance);
    });
    
    console.log('Nombres de departamentos agregados como texto fijo');
  };

  const navigateToMunicipality = (municipio) => {
    const coordenadas = obtenerCoordenadasMunicipio(municipio.municipioID);
    
    if (!coordenadas) {
      console.warn(`Sin coordenadas para ${municipio.nombre}`);
      return;
    }
    
    if (!map) {
      console.warn('Mapa no disponible');
      return;
    }
    
    // Animación suave al municipio
    map.panTo(coordenadas);
    
    setTimeout(() => {
      map.setZoom(12);
    }, 500);
    
    // Buscar y abrir InfoWindow
    setTimeout(() => {
      const marcadorEncontrado = markers.find(marker => {
        const markerPosition = marker.getPosition();
        return Math.abs(markerPosition.lat() - coordenadas.lat) < 0.001 &&
              Math.abs(markerPosition.lng() - coordenadas.lng) < 0.001;
      });
      
      if (marcadorEncontrado && marcadorEncontrado.infoWindow) {
        cerrarTodosLosInfoWindows();
        marcadorEncontrado.infoWindow.open(map, marcadorEncontrado);
        setActiveInfoWindow(marcadorEncontrado.infoWindow);
      }
    }, 1000);
    
    console.log(`Navegando a ${municipio.nombre}:`, coordenadas);
  };

  return (
    <div style={styles.container}>
      {/* Contenedor del mapa */}
      <div style={styles.mapContainer}>
        {/* CONTENEDOR DEL MAPA CON CALLBACK REF PARA DETECTAR CONEXIÓN */}
        <div 
          ref={(element) => {
            if (element && element !== mapRef.current) {
              console.log('mapRef conectándose a elemento:', element);
              mapRef.current = element;
              
              // Verificar si podemos inicializar inmediatamente
              if (!loading && googleMapsLoaded && !map) {
                console.log('Inicializando mapa inmediatamente después de conectar ref');
                setTimeout(() => initializeMap(), 100);
              }
            }
          }}
          style={styles.map}
        />
      </div>

      {/* Botón para mostrar/ocultar filtros */}
      <button
        style={styles.toggleButton}
        onClick={() => setShowFilters(!showFilters)}
        title={showFilters ? 'Ocultar panel' : 'Mostrar panel'}
      >
        {showFilters ? <X size={20} /> : <Filter size={20} />}
      </button>

      {/* Panel lateral */}
      {showFilters && (
        <div 
          ref={sidebarRef}
          style={styles.sidebar}
          onMouseDown={handleMouseDown}
        >
          <div style={styles.dragHandle}>
            <div>
              <h2 style={styles.title}>
                <MapPin size={18} />
                Mapa de Municipios
              </h2>
              <p style={styles.subtitle}>Estados del workflow de inscripción</p>
            </div>
            <Move size={16} style={{ opacity: 0.7 }} />
          </div>

          <div style={styles.content} className="no-drag">
            {/* Debug Info (solo si no está funcionando) */}
            {(!googleMapsLoaded || !map) && (
              <div style={styles.debugBox}>
                <h3 style={styles.debugTitle}>Estado del Sistema</h3>
                <div style={styles.debugText}>
                  Google Maps: {googleMapsLoaded ? 'Si' : 'No'} | 
                  window.google: {!!(window.google) ? 'Si' : 'No'} | 
                  Mapa: {map ? 'Si' : 'No'}
                </div>
                
                {!googleMapsLoaded && (
                  <button
                    style={styles.primaryButton}
                    onClick={async () => {
                      try {
                        await loadGoogleMapsAPI();
                        setGoogleMapsLoaded(true);
                      } catch (error) {
                        console.error('Error:', error);
                      }
                    }}
                  >
                    Cargar Google Maps
                  </button>
                )}
                
                {googleMapsLoaded && !map && (
                  <button
                    style={styles.primaryButton}
                    onClick={initializeMap}
                  >
                    Inicializar Mapa
                  </button>
                )}
              </div>
            )}

            {/* Lista de Municipios */}
            <div style={styles.section}>
              <div style={styles.municipalityBox}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center', 
                  marginBottom: '12px' 
                }}>
                  <h3 style={{...styles.municipalityTitle, margin: 0}}>
                    Municipios en proceso ({getFilteredMunicipalities().length})
                  </h3>
                  
                  {/* Botón de Inscripciones */}
                  <button
                    style={{
                      backgroundColor: '#007bff',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      padding: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      transition: 'background-color 0.2s',
                      minWidth: 'auto',
                      width: '32px',
                      height: '32px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#0056b3';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#007bff';
                    }}
                    onClick={() => window.open('/entidades', '_blank')}
                    title="Ir a Gestión de Inscripciones"
                  >
                    <InscripcionIcon style={{ fontSize: '16px' }} />
                  </button>
                </div>
                
                {/* Scroll container para la lista de municipios */}
                <div style={styles.municipalityScrollContainer}>
                  {getFilteredMunicipalities().length > 0 ? (
                    getFilteredMunicipalities().map((municipio, index) => {
                      const estado = estadosWorkflow[municipio.entidadID || municipio.id] || WORKFLOW_STATES.INICIADO;
                      const coordenadas = obtenerCoordenadasMunicipio(municipio.municipioID);
                      
                      return (
                        <div
                          key={municipio.entidadID || municipio.id}
                          style={{
                            ...styles.municipalityChip,
                            borderColor: estado.color,
                            backgroundColor: coordenadas ? 'white' : '#f8f9fa'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = coordenadas ? '#f8f9fa' : '#e9ecef';
                            e.currentTarget.style.transform = 'translateY(-1px)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = coordenadas ? 'white' : '#f8f9fa';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                          }}
                          onClick={() => navigateToMunicipality(municipio)}
                          title={`Click para ir a ${municipio.nombre}${!coordenadas ? ' (sin coordenadas)' : ''}`}
                        >
                          {/* Indicador de color del estado */}
                          <div style={{
                            ...styles.municipalityChipColor,
                            backgroundColor: estado.color
                          }}></div>
                          
                          {/* Nombre del municipio */}
                          <div style={styles.municipalityChipText}>
                            <div style={styles.municipalityName}>
                              {municipio.nombre.split(' - ')[0]}
                            </div>
                            <div style={styles.municipalityDepartment}>
                              {getDepartamentoFromEntidad(municipio)}
                            </div>
                          </div>
                          
                          {/* Estado del workflow */}
                          <div style={{
                            ...styles.municipalityChipStatus,
                            backgroundColor: estado.color
                          }}>
                            {estado.label}
                          </div>
                          
                          {/* Indicador de coordenadas */}
                          {!coordenadas && (
                            <div style={styles.municipalityNoCoords}>
                              📍❌
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div style={styles.municipalityEmpty}>
                      No se encontraron municipios con los filtros aplicados
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Filtros */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>
                Filtros
              </h3>
              
              <div style={styles.filterGroup}>
                <label style={styles.label}>Departamento:</label>
                <select
                  style={styles.select}
                  value={selectedDepartment}
                  onChange={(e) => {
                    console.log('Departamento seleccionado:', e.target.value);
                    setSelectedDepartment(e.target.value);
                  }}
                >
                  <option value="">Todos los departamentos</option>
                  {departments.map(dept => (
                    <option key={dept} value={dept}>{dept}</option>
                  ))}
                </select>
              </div>

              <div style={styles.filterGroup}>
                <label style={styles.label}>Estado del workflow:</label>
                <select
                  style={styles.select}
                  value={workflowFilter}
                  onChange={(e) => setWorkflowFilter(e.target.value)}
                >
                  <option value="">Todos los estados</option>
                  <option value="1">Proceso Iniciado</option>
                  <option value="2">Pendiente Registro</option>
                  <option value="3">Registro Completado</option>
                  <option value="4">Documentos en Revisión</option>
                  <option value="5">Aprobado</option>
                  <option value="6">Rechazado</option>
                  <option value="7">Pendiente Documentos</option>
                  <option value="8">Documentos Cargados</option>
                  <option value="9">En Revisión Admin</option>
                </select>
              </div>

              {/* Controles de filtros */}
              <div style={styles.buttonGroup}>
                <button
                  style={{...styles.button, backgroundColor: '#dc3545'}}
                  onClick={clearFilters}
                  title="Limpiar todos los filtros"
                >
                  <X size={14} />
                  Limpiar
                </button>
                <button
                  style={styles.button}
                  onClick={() => {
                    if (map) {
                      map.setCenter(MAP_CONFIG.DEFAULT_CENTER);
                      map.setZoom(MAP_CONFIG.DEFAULT_ZOOM);
                    }
                  }}
                  title="Volver a vista de Colombia"
                >
                  Resetear
                </button>
              </div>
            </div>

            {/* Estadísticas */}
            <div style={styles.section}>
              <div style={styles.statsBox}>
                <h3 style={styles.statsTitle}>Estadísticas</h3>
                <div style={styles.statsItems}>
                  <div style={styles.statsItem}>
                    <span style={styles.statsLabel}>Total municipios:</span>
                    <span style={styles.statsValue}>{entidadesMunicipios.length}</span>
                  </div>
                  <div style={styles.statsItem}>
                    <span style={styles.statsLabel}>Mostrando:</span>
                    <span style={styles.statsValue}>{getFilteredMunicipalities().length}</span>
                  </div>
                  <div style={styles.statsItem}>
                    <span style={styles.statsLabel}>Filtros activos:</span>
                    <span style={styles.statsValue}>{hasActiveFilters ? 'Sí' : 'No'}</span>
                  </div>
                  <div style={styles.statsItem}>
                    <span style={styles.statsLabel}>Completados:</span>
                    <span style={styles.statsValue}>
                      {Object.values(estadosWorkflow).filter(e => e.id === 'completado').length}
                    </span>
                  </div>
                  <div style={styles.statsItem}>
                    <span style={styles.statsLabel}>En proceso:</span>
                    <span style={styles.statsValue}>
                      {Object.values(estadosWorkflow).filter(e => 
                        ['registro_iniciado', 'registro_completo', 'documentos_pendientes', 'documentos_en_revision'].includes(e.id)
                      ).length}
                    </span>
                  </div>
                  <div style={styles.statsItem}>
                    <span style={styles.statsLabel}>Con coordenadas:</span>
                    <span style={styles.statsValue}>
                      {entidadesMunicipios.filter(m => obtenerCoordenadasMunicipio(m.municipioID)).length}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Estilo de mapa */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>
                Estilo del mapa
              </h3>
              
              <div style={styles.filterGroup}>
                <label style={styles.label}>Tema:</label>
                <select
                  style={styles.select}
                  value={mapStyle}
                  onChange={(e) => {
                    console.log('Cambiando estilo a:', e.target.value);
                    changeMapStyle(e.target.value);
                  }}
                >
                  <option value="default">Estándar</option>
                  <option value="satellite">Satélite</option>
                  <option value="hybrid">Híbrido</option>
                  <option value="terrain">Terreno</option>
                  <option value="dark">Oscuro</option>
                  <option value="light">Claro</option>
                  <option value="minimal">Minimal</option>
                  {/* <option value="administrative_borders">Con Límites Administrativos</option> */}
                </select>
              </div>
            </div>

            {/* Leyenda */}
            <div style={styles.section}>
              <div style={styles.legendBox}>
                <h3 style={styles.legendTitle}>Leyenda de Estados</h3>
                {Object.values(WORKFLOW_STATES).map(estado => (
                  <div key={estado.id} style={styles.legendItem}>
                    <div style={{...styles.legendColor, backgroundColor: estado.color}}></div>
                    <span style={styles.legendText}>{estado.label}</span>
                  </div>
                ))}
              </div>
            </div>

            
            


          </div>
        </div>
      )}
    </div>
  );
};

export default ColombiaMap;